import { useQuery } from '@tanstack/react-query';
import getAppConfig from '@utils/getAppConfig';

const STALE_TIME_MS = 1000 * 60 * 5;

const useAppConfig = () => {
  const query = useQuery({
    queryKey: ['appConfig'],
    queryFn: getAppConfig,
    staleTime: STALE_TIME_MS,
    enabled: false,
  });

  return {
    ...query,
    // data is always available because query is prefetched in pages/_app.jsx
    data: query.data as NonNullable<typeof query.data>,
  };
};

export default useAppConfig;
